export default __webpack_public_path__ + "static/media/belicosoOpen.af8d832b.jpg";